import moment from 'moment/moment'

export const formatDuration = (secs) => {
    const duration = moment.duration(secs,'seconds');
    let s = ' ' + duration.get('hours') +  ' hours ' + duration.get('minutes') + ' minutes ';
    if ( secs > 3600 * 24 )
        s = ' ' + duration.get('days') +  ' days' + s;
    if ( secs > 3600 * 24 * 28 )
        s = ' ' + duration.get('months') +  ' months' + s;
    return s;
};
